export enum SessionStorageKeys {
    hasSeenTryRefreshedAssignReviewModal = 'hasSeenTryRefreshedAssignReviewModal',
    logout_return_to = 'logout_return_to'
}
